<template>
<div>   
	<div class="container"> 
		<div class="cts-form"> 
			<div v-for="(status, index) in statuses" :key="index" class="cts-field"> 
					<div> 
						<div class="bg-gray rounded shadow-sm">  
							<v-chip class="bg-off-white rounded-3 TodosHeader" :style="{ width:'100%',height:'4rem'}">
								<v-avatar color="white lighten-2 .align-self-center font-weight-medium" size="37">{{status.taskCount}}</v-avatar>
								<input  class="custome_Text_field form-check-label" :value="$t(status.title)" type="text" disabled />									
								<v-btn class="btn-sm" @click="OpenSaveDialog(status.statusId)" title="New" color="white" style="margin: -2px 0px 0px 0px"><i class="fa fa-plus fa-2x"></i></v-btn> 
							</v-chip>
						</div>
					</div>   
			</div> 
		</div>  

		<div class="cts-form mt-1" v-show="showTasksSkeleton"> 
			<div  class="cts-field m-0 p-0" v-for="col in 3" :key="col">   
				<div v-for="colCel in 3" :key="colCel" class="w-100 m-0 ToDoSkeleton" >  
						<v-skeleton-loader  type="text">
						</v-skeleton-loader>
				</div> 
			</div>  
		</div> 

		<div class="cts-form mt-1" v-show="!showTasksSkeleton"> 
			<Container  :should-accept-drop="shouldAcceptDrop" group-name="col" class="cts-field m-0 p-0" v-for="(status, index) in statuses" :key="index" @drop="OnDrop">  
				<Draggable  v-for="(toDo, toDo_index) in status.tasks" :key="toDo_index" class="w-100 m-0"  drag-handle-selector=".column-drag-handle"> 
					<div class="bg-white rounded shadow-sm p-3 column-drag-handle ToDoCard" @mousedown="startDrag(toDo.id)"> 
						<p>{{toDo.text}}</p>  
						<div class="d-flex align-items-center justify-content-between gap-2 mt-1">
							<span class="bg-gray p-1 rounded shadow-sm font-weight-medium">{{toDo.date}}</span>
							<v-btn class="btn-sm" @click="deleteTaskdetails(toDo.id)" title="Delete" color="white">
								<span class="mdi mdi-close"></span>
							</v-btn>
						</div>
					</div>  
				</Draggable> 
			</Container>  
		</div> 
	</div> 

	<v-dialog v-model="NewToDoDialog"  content-class="ToDoDialog" >
		<v-card>
			<v-toolbar class="bg-white">
				<v-card-title class="p-0">{{ $t("res_DialogTitle_AddEditTask") }}</v-card-title>
				<v-spacer></v-spacer>
				<v-btn class="close-btn light-btn" icon dark @click="NewToDoDialog = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar> 
			<v-card-text>
				<div class="mb-2">
					<v-label>{{ $t("res_Label_Text") }}*</v-label>
					<v-textarea rows="2"  @input="checkMaxLength"  v-model="newTask.text" label="" solo></v-textarea>
				</div>  
				<div class="mb-2">
					<v-label>{{ $t("res_GridHeaders_Date") }}*</v-label>
					<v-menu offset-y content-class="p-0" v-model="task_date_datePicker" :close-on-content-click="true" >
						<template v-slot:activator="{ on, attrs }">
							<v-text-field  :value="newTask.date"  :label="$t('res_Label_SelectDate')" readonly v-bind="attrs" v-on="on" solo append-icon="mdi-calendar" 
								:tabindex="-1">
								<template v-slot:append>
									<v-icon v-bind="attrs" v-on="on" >mdi-calendar</v-icon>
								</template>
							</v-text-field>
						</template>
						<v-date-picker :locale="lang" v-model="newTask.date"></v-date-picker>
					</v-menu>
				</div> 
			</v-card-text> 
			<v-card-actions class="gap-2 sticky-actions">
				<v-spacer></v-spacer>
				<v-btn class="light-blue" style="min-width: 100px !important" @click="NewToDoDialog = false" >{{ $t("res_ButtonText_Cancel") }}</v-btn>
				<v-btn class="primary" style="min-width: 100px !important" @click="SaveTask()">{{ $t("res_ButtonText_Continue") }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import axios from "axios";
import constants from "@/assets/js/constants.js"
import { Container, Draggable } from "vue-smooth-dnd"

export default {
	name: "ToDoLists",
	components: { Container, Draggable },
	data() {
		return {
			showTasksSkeleton: true,
			colNumber: -1,
			removedIndex: -1,
			addedIndex: -1,
			NewToDoDialog: false,
			selectedStatusId: 0,
			selectedTaskIdOnDrag: 0,
			task_date_datePicker: false,
			statuses: [], 
			newTask: {
				id: 0,
				statusId: 0,
				text: "",
				date: "",
			},
			selectedTaskTitlefield: 0,
			selectedSubTaskField: 0,
			selectedSubtaskList: 0,
			lang: localStorage.getItem('lang')
		};
	}, 
	mounted() {
		this.FetchData();
	}, 
	methods: {
		shouldAcceptDrop(sourceContainerOptions, payload) {
			return true;
		},
		OnDrop(dropResult) {
			this.colNumber = this.colNumber + 1;
			if (dropResult.addedIndex != null) {
				this.addedIndex = this.colNumber;
			} else if (dropResult.removedIndex != null) {
				this.removedIndex = this.colNumber;
			}
			if (this.removedIndex > -1 && this.addedIndex > -1) {
				this.showTasksSkeleton = true;
				this.DropTask(
					this.statuses[this.addedIndex].statusId,
					this.selectedTaskIdOnDrag,
					this.statuses[this.addedIndex].title
				);
				this.removedIndex = -1;
				this.addedIndex = -1;
				this.colNumber = -1;
			}
		},
		DropTask(statusid, taskId, statusName) {
			const item = this.statuses.find(
				(item) => item.statusId == statusid
			);
			if (taskId == null || taskId == undefined || taskId == "") {
				return;
			} else {
				this.updateTaskStatusCallApi(statusid, taskId, statusName);
				this.clearNewTask();
			}
		},
		startDrag(id) {
			this.colNumber = -1;
			this.selectedTaskIdOnDrag = id;
		},
		clearNewTask() {
			this.$nextTick(() => { 
				this.newTask.id = 0;
				this.newTask.text = ""; 
				this.newTask.date = "";
			});
		},
		isFormValid() {
			let valid = true;
			if (
				this.newTask.text == null ||
				this.newTask.text == undefined ||
				this.newTask.text == "" ||
				this.newTask.date == null ||
				this.newTask.date == undefined ||
				this.newTask.date == ""
			) {
				valid = false;
			}
			if (valid == false) {
				window.showAlert("res_Msgs_FillRequired", "warning");
			}
			return valid;
		},
		async saveToDoList(FormData) {
			if (!this.isFormValid()) {
				return;
			}
			try {
				const response = await axios.post(
					`${constants.baseApiUrl}user/SaveToDoList`,
					FormData
				);
				if (response.data.success) {
					this.NewToDoDialog = false;
					this.FetchData();
					this.clearNewTask();
				}
				console.log("Response:", response.data);
			} catch (error) {
				console.error("Error:", error);
			}
		}, 
		deleteTaskdetails(id) {
			window.showInformation(
				window.translate("res_Msg_Close"),
				window.translate("res_Msgs_DeletConfirmation"),
				() => {
					this.deleteTask(id);
					this.clearNewTask();
				},
				() => {}
			);
		},
		deleteTask(id) {
			axios
				.post(constants.baseApiUrl + `user/DeleteToDoList?id=${id}`)
				.then((res) => {
					if (res.data) {
						window.showAlert(
							this.$t("res_Msgs_FilingOrClassificationDeleted"),
							"success"
						);
						this.FetchData();
					}
				})
				.catch((err) => console.warn(err));
		},
		updateTaskStatusCallApi(statusId, taskId, statusName) {
			axios
				.patch(
					constants.baseApiUrl +
						`user/ChangeToDoListStatus/${taskId}?statusId=${statusId}`
				)
				.then((res) => {
					if (res.data) {
						this.FetchData();
						window.showAlert(
							this.$t("res_Msgs_SuccessfulSave"),
							"success"
						);
					}
				})
				.catch((err) => console.warn(err));
		},
		FetchData() {
			this.showTasksSkeleton = true;
			axios
				.get(constants.baseApiUrl + `user/GetToDoLists`)
				.then((res) => {
					this.statuses = res.data;
					this.showTasksSkeleton = false;
				})
				.catch((err) => console.warn(err));
		},
		OpenSaveDialog(statusId) {
			this.selectedStatusId = statusId;
			this.MainDialogClass = "smaller-dialog";
			this.NewToDoDialog = true;
		},
		SaveTask() {
			this.newTask.statusId = this.selectedStatusId;
			const formData = {
				text: this.newTask.text,
				statusId: this.newTask.statusId,
				date: this.newTask.date,
			};
			this.saveToDoList(formData);
		},
		checkMaxLength() {
			if (this.newTask.text.length > 500) {
				this.$nextTick(() => {
					this.newTask.text = this.newTask.text.substring(0, 500);
				});
			}
		},
	},
};
</script>
<style> 

.ToDoSkeleton .v-skeleton-loader__text {
		height:130px; 
 }

.ToDoDialog {
	width:700px !important;
	max-width: 100%;
}
.TodosHeader .v-chip__content
{
	width: 100% !important;
}
</style>
<style scoped> 
.ToDoCard
{
	 cursor: move !important;
}

.ToDoCard p
{ 
		margin-bottom: 0 !important;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		line-height: 20px;
		max-height: 100px;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
		white-space: pre-line; 
}

.ToDoCard span{
	color:#10357e;
	font-size:11px;
	cursor: default !important;
}
.ToDoCard button
{
	cursor: pointer !important;
	background-color: #E3E9EE !important;
	color:#10357e !important;
}

.ToDoCard button span
{
	cursor: pointer !important; 
}

.crounderbtn {
	border-radius: 50%;
}

.column-width {
	min-width: 320px;
	width: 320px;
}

.margin-row {
	margin: 5px;
}

.ghost-card {
	opacity: 0.5;
	background: #F7FAFC;
	border: 1px solid #4299e1;
	min-height: 100px;
}

.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	width: 300px;
	margin: 0px auto;
	padding: 20px 30px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 20px 0;
}

.modal-default-button {
	float: right;
}

.modal-enter-from {
	opacity: 0;
}

.modal-leave-to {
	opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.horizontal-scroll-container {
	overflow-x: auto;
	/* Enable horizontal scrolling */
	white-space: nowrap;
	/* Prevent content from wrapping to a new line */
	width: 100%;
	min-height: 650px;
}

.scroll-content {
	display: flex;
}

.custome_Text_field {
	outline: none;
	height: 32px;
	color: #10357e;
	font-size: 18px;
	font-weight: 500;
	flex: 1 1 auto;
	line-height: 20px;
	padding: 0 10px;
	max-width: 100%;
	min-width: 0;
	width: 100%;
	background-color: transparent;
}

.resizable {
	overflow: scroll;
	resize: both;
	max-width: 1328px;
	max-height: 460px;
	min-width: 1328px;
	min-height: 757px;
}

[draggable=true] {
	cursor: move;
}

.theme {
	background-color: rgb(245, 247, 249);
}

.avatar-container {
	top: 20px;
	/* Adjust the top position as needed */
	left: 20px;
	/* Adjust the left position as needed */
}

.imgSide {
	border: 0 !important;
	width: 10%;
}

.hide_overflow {
	overflow: hidden !important;
	max-height: 100% !important;
}



::-webkit-scrollbar {
	width: 0.7em;
}

/* ::-webkit-scrollbar-track {} */

::-webkit-scrollbar-thumb {
	background-color: rgb(224, 219, 219);
}

.user_search_scrollable1 {
	max-height: 350px;
	overflow-y: auto;
	text-align: justify;
}

.custome_Text_field_for_subtask {
	outline: none;
	height: 32px;
	color: #10357e;
	font-size: 17px;
	flex: 1 1 auto;
	line-height: 20px;
	padding-left: 10px;
	max-width: 100%;
	min-width: 0;
	width: 100%;
	background-color: transparent;
}

.v-list-item {
	padding: 0;
	margin: 0;
}

.v-list .v-list-item:hover {
	background-color: rgb(239, 234, 234);
	/* Set the background color to transparent on hover */
}

.block_hover {
	/* background-color: 'none';*/
	pointer-events: none !important;

}

.form-check-input:checked {
	background-color: #024976;
	border-color: #024976;
}

.mdi-checkbox-marked {
	background-color: #024976;
	border-color: #024976;
}

.v-input--selection-controls {
	margin-top: -2px;
	padding-top: 6px;
}

.expanded-div {
	height: 200px;
	/* Set an initial height */
	overflow: hidden;
	/* Hide overflowing content */
	transition: height 0.3s ease;
	/* OpenSaveDialog a smooth transition effect */
}

.center-chip {
	display: flex;
	justify-content: center;
	align-items: center;
	/*height: 100vh;  Adjust the height as needed */
}</style>


